import { SET_LANG } from "../actions/type";
import { DEFAULT_LANG } from "constants/settings";

function settings(state = { lang: localStorage.getItem("i18nextLng") || DEFAULT_LANG }, action) {
    if (action.type === SET_LANG) {
        return { ...state, lang: action.payload };
    }
    return state;
}

export default settings;
